import { Component, inject } from '@angular/core';
import { BreadcrumbService } from '../../lib/services';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrl: './breadcrumb.component.scss',
    imports: [
        CommonModule,
        TranslatePipe,
        RouterModule
    ]
})
export class BreadcrumbComponent {
    readonly breadcrumbService: BreadcrumbService = inject(BreadcrumbService);
}
